import api from './apiClient';

export interface UserSettingsResponse {
  id: number;
  user_id: number;
  marketing_emails: boolean;
  created_at: string;
  updated_at: string;
}

export interface UserSettingsUpdate {
  marketing_emails: boolean;
}

export const userSettingsApi = {
  getSettings: async (): Promise<UserSettingsResponse> => {
    const response = await api.get('/user-settings');
    return response.data;
  },

  updateSettings: async (settings: UserSettingsUpdate): Promise<UserSettingsResponse> => {
    const response = await api.put('/user-settings', settings);
    return response.data;
  },
};

